import Box from '@mui/material/Box';

/** Ranked label / track / % rows used for districts, mandals, cities and profiles. */
export default function GeoBarList({ items }) {
  const mx = Math.max(...items.map((i) => i.v), 0.0001);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '7px', mt: 0.5 }}>
      {items.map((i) => (
        <Box
          key={i.k}
          onClick={i.onClick}
          sx={{
            display: 'grid',
            gridTemplateColumns: '132px 1fr 42px',
            alignItems: 'center',
            gap: 1.25,
            p: '3px 5px',
            borderRadius: '8px',
            cursor: i.onClick ? 'pointer' : 'default',
            '&:hover': i.onClick ? { background: 'var(--card-2)' } : null,
          }}
        >
          <Box sx={{ fontSize: 12.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {i.k}
            {i.sub && (
              <>
                {' '}
                <Box component="span" sx={{ color: 'var(--muted)', fontSize: 10.5, fontFamily: 'var(--mono)' }}>
                  {i.sub}
                </Box>
              </>
            )}
          </Box>
          <Box sx={{ height: 10, background: 'var(--card-2)', borderRadius: '5px', overflow: 'hidden' }}>
            <Box
              sx={{
                height: '100%',
                borderRadius: '5px',
                transition: 'width .2s',
                width: `${Math.max(2, (100 * i.v) / mx)}%`,
                background: i.color || 'var(--s1)',
              }}
            />
          </Box>
          <Box sx={{ textAlign: 'right', fontFamily: 'var(--mono)', fontSize: 12, fontWeight: 600 }}>
            {(100 * i.v).toFixed(0)}%
          </Box>
        </Box>
      ))}
    </Box>
  );
}
